<template>
  <tr class="tw:group/item">
    <td class="tw:align-middle">
      <div class="tw:flex tw:gap-3 tw:relative">
        <div class="tw:w-12 tw:shrink-0 tw:hidden tw:md:block">
          <template v-if="registration.avatar_url">
            <img onerror="this.style.display='none'" :src="registration.avatar_url"
                 :alt="registration.lastname + ' ' + registration.firstname" class="tw:w-full tw:rounded-full"/>
          </template>
          <template v-else>
            <img src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDUwIDUwIiBoZWlnaHQ9IjUwcHgiIGlkPSJMYXllcl8xIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCA1MCA1MCIgd2lkdGg9IjUwcHgiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxjaXJjbGUgY3g9IjI1IiBjeT0iMjUiIGZpbGw9Im5vbmUiIHI9IjI0IiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjIiLz48cmVjdCBmaWxsPSJub25lIiBoZWlnaHQ9IjUwIiB3aWR0aD0iNTAiLz48cGF0aCBkPSJNMjkuOTMzLDM1LjUyOCAgYy0wLjE0Ni0xLjYxMi0wLjA5LTIuNzM3LTAuMDktNC4yMWMwLjczLTAuMzgzLDIuMDM4LTIuODI1LDIuMjU5LTQuODg4YzAuNTc0LTAuMDQ3LDEuNDc5LTAuNjA3LDEuNzQ0LTIuODE4ICBjMC4xNDMtMS4xODctMC40MjUtMS44NTUtMC43NzEtMi4wNjVjMC45MzQtMi44MDksMi44NzQtMTEuNDk5LTMuNTg4LTEyLjM5N2MtMC42NjUtMS4xNjgtMi4zNjgtMS43NTktNC41ODEtMS43NTkgIGMtOC44NTQsMC4xNjMtOS45MjIsNi42ODYtNy45ODEsMTQuMTU2Yy0wLjM0NSwwLjIxLTAuOTEzLDAuODc4LTAuNzcxLDIuMDY1YzAuMjY2LDIuMjExLDEuMTcsMi43NzEsMS43NDQsMi44MTggIGMwLjIyLDIuMDYyLDEuNTgsNC41MDUsMi4zMTIsNC44ODhjMCwxLjQ3MywwLjA1NSwyLjU5OC0wLjA5MSw0LjIxYy0xLjI2MSwzLjM5LTcuNzM3LDMuNjU1LTExLjQ3Myw2LjkyNCAgYzMuOTA2LDMuOTMzLDEwLjIzNiw2Ljc0NiwxNi45MTYsNi43NDZzMTQuNTMyLTUuMjc0LDE1LjgzOS02LjcxM0MzNy42ODgsMzkuMTg2LDMxLjE5NywzOC45MywyOS45MzMsMzUuNTI4eiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSIyIi8+PC9zdmc+"
                 :alt="registration.lastname + ' ' + registration.firstname"  class="tw:w-full tw:rounded-full">
          </template>
        </div>

        <div class="flex-grow-1">
          <a :href="registration.links.show" @click="onClickRegistration" class="tw:font-bold">
            <span class="tw:absolute tw:inset-0" aria-hidden="true"></span>
            <text-highlight :query="search" :splitBySpace="true">
              {{registration.lastname}} {{registration.firstname}}
            </text-highlight>
          </a>
          <span v-if="registration.company" class="text-muted tw:ml-1">({{ registration.company }})</span>
          <small class="tw:block tw:mb-0">
            <span class="tw:inline-block text-muted">
              <text-highlight :query="search" :splitBySpace="true">
                {{registration.email}} {{ registration.phone }}
              </text-highlight>
            </span>
            <span v-if="registration.account_id" class="badge badge-info tw:ml-2">
                <i aria-hidden="true" class="fa fa-user-circle-o"></i> Account
            </span>
          </small>
          <div class="tw:md:hidden">
            <span v-if="registration.barcode"  class="tw:font-mono tw:text-sm tw:whitespace-nowrap">
              <i class="fa fa-qrcode tw:mr-1 tw:align-middle" aria-hidden="true"></i>
              <text-highlight :query="search" :splitBySpace="true">
                {{ registration.barcode }}
              </text-highlight>
            </span>
            <div>
              <span v-for="tag in registration.tags" :key="tag.id" class="badge badge-pill badge-secondary  text-truncate">
                <i class="fa fa-tag" aria-hidden="true"></i>
                {{ tag.name }}
              </span>
            </div>
          </div>
        </div>
        <div class="tw:md:hidden">
          <RegistrationStatus class="tw:text-xl" :status="registration.status"/>
        </div>
      </div>
    </td>
    <td class="tw:align-middle tw:hidden tw:md:table-cell">
      <span v-if="registration.barcode"  class="tw:font-mono tw:text-sm tw:whitespace-nowrap">
          <i class="fa fa-qrcode tw:mr-1 tw:align-middle" aria-hidden="true"></i>
          <text-highlight :query="search" :splitBySpace="true">
            {{ registration.barcode }}
          </text-highlight>
      </span>
    </td>
    <td class="tw:align-middle tw:hidden tw:md:table-cell">
        <span v-for="stage in registration.stages" :key="'stage_'  + stage.id"
            class="badge badge-light text-truncate mr-2">
          {{ stage.name }}
        </span>
    </td>
    <td class="tw:align-middle tw:hidden tw:md:table-cell">
        <span v-for="tag in registration.tags" :key="'tag_' + tag.id" class="badge badge-pill badge-secondary">
          <i class="fa fa-tag" aria-hidden="true"></i>
          {{ tag.name }}
        </span>
    </td>
    <td class="tw:align-middle tw:hidden tw:md:table-cell">
        <small class="text-muted">
          {{ new dayjs(registration.created_at).format('ll') }}
        </small>
    </td>
    <td class="tw:align-middle tw:hidden tw:md:table-cell">
      <span class="badge tw:bg-zinc-200/50">
          {{registration.product_tests_count}}
      </span>
    </td>
    <td class="tw:align-middle tw:hidden tw:md:table-cell">
      <RegistrationStatus class="tw:text-xl" :status="registration.status" />
    </td>
  </tr>
</template>

<script setup>
import RegistrationStatus from "@/components/registration/RegistrationStatus.vue";
import dayjs from "dayjs";

const props = defineProps({
  registration: {
    required: true
  },
  search: {
    type: String,
  },
  openOnClick: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['registration-clicked']);

const onClickRegistration = (event) => {
  if (props.openOnClick) {
    return; // let the link open the registration
  }
  event.preventDefault();
  event.stopPropagation();
  // emit event to parent
  emit('registration-clicked');
}

</script>
